import { AssetType } from "../../types";
import { ERubbingDestination } from "../trench/types";
function fromOld(jsonString, defaultPointCloudId) {
    const flatGroundData = JSON.parse(jsonString);
    const associatePointCloudId = defaultPointCloudId;
    return {
        flatGroundAreaId: flatGroundData.flatGroundAreaId,
        flatGroundSettings: flatGroundData.flatGroundSettings,
        points: flatGroundData.points,
        associatedTerrain: {
            id: associatePointCloudId,
            terrainType: AssetType.Point_Cloud,
        },
        rubbingDestination: {
            target: ERubbingDestination.POINT_CLOUD,
            id: associatePointCloudId,
        },
    };
}
function fromVersion1(jsonString) {
    const flatGroundData = JSON.parse(jsonString);
    if (!flatGroundData.associatePointCloudId &&
        !flatGroundData.associateDrawing2dImageId) {
        throw new Error("Flat ground data must have either associatePointCloudId or associateDrawing2dImageId");
    }
    return {
        flatGroundAreaId: flatGroundData.flatGroundAreaId,
        flatGroundSettings: flatGroundData.flatGroundSettings,
        points: flatGroundData.points,
        associatedTerrain: flatGroundData.associatePointCloudId
            ? {
                id: flatGroundData.associatePointCloudId,
                terrainType: AssetType.Point_Cloud,
            }
            : {
                id: flatGroundData.associateDrawing2dImageId,
                terrainType: AssetType.REFERENCE_TOPOLOGY,
            },
        rubbingDestination: flatGroundData.associatePointCloudId
            ? {
                target: ERubbingDestination.POINT_CLOUD,
                id: flatGroundData.associatePointCloudId,
            }
            : {
                target: ERubbingDestination.REFERENCE_TOPOLOGY,
                id: flatGroundData.associateDrawing2dImageId,
            },
    };
}
function fromVersion2(jsonString) {
    const flatGroundData = JSON.parse(jsonString);
    return {
        flatGroundAreaId: flatGroundData.flatGroundAreaId,
        flatGroundSettings: flatGroundData.flatGroundSettings,
        points: flatGroundData.points,
        associatedTerrain: {
            id: flatGroundData.associatedTerrain.id,
            terrainType: flatGroundData.associatedTerrain.terrainType,
        },
        rubbingDestination: flatGroundData.rubbingDestination,
    };
}
export var FlatGroundSavedData;
(function (FlatGroundSavedData) {
    function parseFlatGroundSavedData(jsonString, defaultPointCloudId) {
        let roadData;
        const jsonData = JSON.parse(jsonString);
        switch (jsonData.version) {
            case undefined:
                roadData = fromOld(jsonString, defaultPointCloudId);
                break;
            case 1.0:
                roadData = fromVersion1(jsonString);
                break;
            case 2.0:
                roadData = fromVersion2(jsonString);
                break;
            default:
                throw new Error(`Unknown flat ground data version: ${jsonData.version}`);
        }
        return roadData;
    }
    FlatGroundSavedData.parseFlatGroundSavedData = parseFlatGroundSavedData;
})(FlatGroundSavedData || (FlatGroundSavedData = {}));
//# sourceMappingURL=flatground-data.js.map